import Header from "@/types/app/header";

export default class CustomerHeader {
  public static header: Header[] = [
    {
      text: "Date",
      align: "start",
      sortable: true,
      value: "date",
      class: "item-table-header",
      width: ""
    },
    {
      text: "Email",
      align: "start",
      sortable: true,
      value: "email",
      class: "item-table-header",
      width: ""
    },
    {
      text: "Name",
      align: "start",
      sortable: true,
      value: "fullName",
      class: "item-table-header",
      width: ""
    },
    {
      text: "Country",
      align: "start",
      sortable: true,
      value: "country",
      class: "item-table-header",
      width: ""
    },
    {
      text: "Relationship with Leste",
      align: "start",
      sortable: true,
      value: "relationship",
      class: "item-table-header",
      width: ""
    },    
    {
      text: "", align: "right", value: "actions", sortable: false, class: null,
      width: "" }
  ];
}
